@if (!isLoading) {
  <div class="full-container">
    @if (isDocumentLocked()) {
      <app-locked-takeover
        [lastLockedBy]="model.lastLockedBy"
      ></app-locked-takeover>
    }
    <app-digitization-top-nav
      [document]="reviewQueueItem"
      (saveMethod)="saveAndStay()"
      (nextMethod)="next()"
      >
      @if (hasTranslations()) {
        <div header-action class="toggler translate-toggle">
          <label>Translate to English</label>
          <i class="fas"
            [ngClass]="{'fa-toggle-off': viewInNativeLanguage, 'fa-toggle-on': !viewInNativeLanguage}"
          (click)="swapLanguage()"></i>
        </div>
      }
      @if (activePage != null) {
        <div>
          <div class="toggler">
            <label>Show Document</label>
            <i class="fas" [ngClass]="{'fa-toggle-off': !splitscreenOpen, 'fa-toggle-on': splitscreenOpen}"
            (click)="toggleSplitScreen()"></i>
          </div>
        </div>
        <div class="d-flex flex-row align-items-center flex-wrap">
          <label class="d-flex align-items-center">Set Currency </label>
          <select class="form-select w-auto" (change)="changeCurrency($event.target.value)">
            @for (currency of supportedCurrencies; track currency) {
              <option [value]="currency.key"
                [selected]="currency.key === this.model.currency">
                {{currency.key}} ({{currency.symbol}})
              </option>
            }
          </select>
        </div>
        <div class="d-flex flex-row align-items-center flex-wrap">
          <label class="d-flex align-items-center">Statement Type
            <i class="fa fa-question-circle ms-2" aria-hidden="true">
              <div class="statementTypeToolTip">The statement type for this specific page</div>
            </i>
          </label>
          <select [(ngModel)]="model.document.pages[activePage].statementType"
            (change)="handleStatementTypeSelectorChange()"
            [ngClass]="{'is-invalid': !_pageHasValidStatementTypeSelected(activePage)}"
            class="form-select w-auto" id="inputGroupSelect01">
            <option value="">Select Statement Type</option>
            <option value="INCOME_STATEMENT">Income Statement</option>
            <option value="BALANCE_SHEET">Balance Sheet</option>
            <option value="CASH_FLOW_STATEMENT">Cash Flow Statement</option>
          </select>
        </div>
        @if (!(splitscreenOpen && _sharedDataService.shouldShowManualReviewSidebar)) {
          <div class="d-flex flex-row align-items-center flex-wrap">
            <label class="d-flex align-items-center">Multiply By
              <i class="fa fa-question-circle ms-2" aria-hidden="true">
                <div class="multiplyByToolTip">Multiplies values from financial statement that were reported as rounded. Changes will take effect after spread completion.</div>
              </i>
            </label>
            <select [(ngModel)]="roundingSelection"
              [ngClass]="{'is-invalid': isRoundingDropdownInvalid}"
              (change)="updateRoundingDropdownValidity()"
              class="form-select w-auto" id="roundingInput" [disabled]="isRoundingDropdownDisabled">
              <option selected disabled [value]="null">Select</option>
              <option value="ACTUALS">Actuals</option>
              <option value="HUNDREDS">Hundreds</option>
              <option value="THOUSANDS">Thousands</option>
              <option value="MILLIONS">Millions</option>
              <option value="BILLIONS">Billions</option>
              <option value="TRILLIONS">Trillions</option>
              <option value="LAKHS">Lakhs (100,000)</option>
              <option value="CRORES">Crores (10,000,000)</option>
            </select>
          </div>
        }
        @if (isAdditionalInformationShown()) {
          <div [ngClass]="{'none': splitscreenOpen}"
            >
            <label>Additional Information</label>
            <br/>
            <textarea
            disabled>{{model.jobPayload.documentFile.additionalInformation}}</textarea>
          </div>
        }
        <div
          [ngClass]="{ 'none': (splitscreenOpen && _sharedDataService.shouldShowManualReviewSidebar )}">
          <div>
            <a [ngClass]="{'disabled': isLoading}" class="btn btn-outline-danger"
            href="javascript:void(0);" (click)="deletePage(activePage)">Delete Statement</a>
          </div>
        </div>
      }
    </app-digitization-top-nav>
    <div class="non-header-content-container">
      <div
        class="left-content"
        [ngClass]="{'split-screen-left': splitscreenOpen}"
        [ngStyle]="splitscreenOpen ? { 'flex-basis.%': leftPaneWidthPercent } : null"
        [style.minWidth.%]="splitscreenOpen ? 19 : 0"
        >
        @if (_sharedDataService.shouldShowManualReviewSidebar) {
          <app-maximized-sidebar
            [model]="model"
            [stepHeader]="stepHeader"
            [steps]="steps"
            [tipsBody]="tipsBody"
            (toggleSidebar)="toggleStepsToSuccess()">
          </app-maximized-sidebar>
        }
        @if (splitscreenOpen) {
          <div class="splitscreen-wrapper">
            <app-document-view-split-screen
              [documentFileType]="modelCopy.document.type"
              [originalFileUrl]="modelCopy?.originalFileUrl"
              [pageImgUrls]="modelCopy?.pageImgUrls"
              [documentPages]="modelCopy.document?.pages"
              [documentFileId]="modelCopy?.documentFileId"
              [viewSourcePage]="viewSource ? viewSourcePage : null"
              [viewSourceBox]="viewSource ? viewSourceBox : null"
              (closeSplitscreen)="closeSplitscreen()">
            </app-document-view-split-screen>
          </div>
        }
      </div>
      @if (splitscreenOpen) {
        <div
          class="split-resize-handle"
          [ngClass]="{ 'is-resizing': isResizingSplit }"
          (mousedown)="resizeSplitMouseDown($event)"
        ></div>
      }
      <div
        class="right-content"
        [ngClass]="{'split-screen-right': splitscreenOpen}"
        [ngStyle]="splitscreenOpen ? { 'flex-basis.%': rightPaneWidthPercent } : null"
        >
        @if (!isError) {
          <div class="main-column" #mainColumn>
            <div class="cell-validation-tooltip" [ngStyle]="cellValidationStyle"
              [ngClass]="{'shown': cellValidationMessage}">
              @if (cellValidationHeading) {
                <div class="cell-validation-heading">{{cellValidationHeading}}</div>
              }
              <div class="cell-validation-description">{{cellValidationMessage}}</div>
            </div>
            <div class="table-container fixedTable">
              <div class="table-wrap">
                <hot-table [afterInit]="afterTableInit" [colHeaders]="true" [rowHeaders]="true"
                  [hotId]="hotId"
                  [data]="pageData" [settings]="{renderer: renderCell, contextMenu: contextMenu}"
                  [licenseKey]="handsOnTableLicense"
                ></hot-table>
              </div>
            </div>
          </div>
        }
        @if (isError) {
          <div>
            <h1>Something went wrong.</h1>
            <h2>We've been alerted and are already looking into it.</h2>
          </div>
        }
        @if (!isError) {
          <app-ai-disclaimer-banner [flagKey]="bedrockTableMetadataFlag"></app-ai-disclaimer-banner>
          <div class="page-nav">
            <nav class="navbar navbar-expand p-0 navbar-financials">
              <ul class="navbar-nav me-auto horizontal-scroll-wrapper">
                @for (page of model.document.pages; track page; let i = $index) {
                  <li
                            [ngClass]="{
                                'active': activePage == i,
                                'error-tab': pageStatuses[i] == ERROR_STATUS,
                                'warning-tab': pageStatuses[i] == WARNING_STATUS,
                                'success-tab': !pageStatuses[i]
                            }"
                    >
                    <a href="javascript:void(0);" class="nav-link" (click)="showPage(i)">
                      <span class="list-group-item-text">
                                    <i class="fas fa-solid fa-circle-check pe-2" [ngClass]="{
                                        'fa-circle-xmark': pageStatuses[i] == ERROR_STATUS,
                                        'fa-triangle-exclamation': pageStatuses[i] == WARNING_STATUS,
                                        'fa-circle-check': !pageStatuses[i]
                                    }"></i>
                        @if (model.document.pages[i].statementType) {
                          <span>
                            {{model.document.pages[i].statementType | docType | titlecase}}
                          </span>
                        }
                        <i class="fas fa-times delete-page" (click)="deletePage(i)"></i>
                      </span>
                    </a>
                  </li>
                }
                <li>
                  <a class="list-group-item add-page page nav-link" href="javascript:void(0);" (click)="addPage()">
                    <span class="list-group-item-text"><i class="fas fa-plus"></i></span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        }
      </div>
    </div>
  </div>
}

@if (isLoading) {
  <div class="col-12 review-editor-loader-wrapper">
    <div class="loader"></div>
  </div>
}
